<div class="nav-element-outer" [ngClass]="{'toggle': showChildren}">
    <a class="nav-element" (click)="onClick($event)" [ngClass]="{'highlight': active}">
        <div class="nav-element__inner">
            <span class="nav-element__icon">
                <fa-icon [icon]="theFaIcon" *ngIf="faIcon && theFaIcon"></fa-icon>
                <img [src]="icon"  *ngIf="icon && !faIcon"/>
            </span>
            <span class="nav-element__inner-text">
                {{text}}
            </span>
            <span class="nav-element__chevron" (click)="$event.preventDefault(); showChildren = !showChildren">
                <fa-icon [icon]="faChevron" *ngIf="children"></fa-icon>
            </span>
        </div>

    </a>

    <ul>
        <li *ngFor="let x of children">
            <mayne-nav-element (clickEvent)="onClick($event)" [text]="x.text" [icon]="x.icon" [path]="x.path"
                [children]="x.children"></mayne-nav-element>
        </li>
    </ul>
</div>